/* POSTIFULL v101 (2026-11-02) - Musteri yorumu fotograflarinin yonu.
   Trendyol CDN'i (cdn.dsmcdn.com) tarayiciya bazi fotograflari WebP olarak, piksel olarak yan duran ve
   donme bilgisi EXIF'te kalan halde gonderiyor; tarayicilar WebP'de bu bilgiyi uygulamadigi icin foto yatay gorunuyor.
   Cozum: ayni adres JPEG olarak istenir (Accept: image/jpeg, CDN CORS'a izin veriyor); JPEG'de tarayici EXIF yonunu uygular.
   Sayfadaki tum yorum fotograflari (ana sayfa galerisi, urun sayfasi yorumlari, guven seridi) ekrana yaklasinca duzeltilir.
   Orijinal adres img.dataset.pfSrc'de saklanir. window.pfRvJpeg(url) -> Promise<blobURL> (assets/pf-rv-lightbox.js kullanir). */
(function () {
  'use strict';
  if (window.__pfRvOr) return;
  window.__pfRvOr = true;
  var RX = /^https?:\/\/cdn\.dsmcdn\.com\/.*review-media/i;
  var cache = {};

  function jpeg(u) {
    if (!cache[u]) {
      cache[u] = fetch(u, { headers: { Accept: 'image/jpeg' }, mode: 'cors', credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
        .then(function (b) { return URL.createObjectURL(b); });
      cache[u].catch(function () { delete cache[u]; });
    }
    return cache[u];
  }
  window.pfRvJpeg = jpeg;

  function fix(img) {
    var s = img.getAttribute('src') || '';
    if (!RX.test(s) || img.dataset.pfOr === s) return;
    img.dataset.pfOr = s;
    img.dataset.pfSrc = s;
    jpeg(s).then(function (b) {
      if (img.getAttribute('src') !== s) return;
      img.removeAttribute('srcset');
      img.src = b;
    }).catch(function () {});
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fix(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;

  function want(img) {
    var s = img.getAttribute('src') || '';
    if (!RX.test(s) || img.dataset.pfOr === s) return;
    if (io) io.observe(img); else fix(img);
  }
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'IMG') { want(root); return; }
    root.querySelectorAll('img[src*="dsmcdn"]').forEach(want);
  }

  function start() {
    scan(document);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.tagName === 'IMG') want(m.target); return; }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
